import { render, staticRenderFns } from "./pointdynomic.vue?vue&type=template&id=6479b549&scoped=true&"
import script from "./pointdynomic.vue?vue&type=script&lang=js&"
export * from "./pointdynomic.vue?vue&type=script&lang=js&"
import style0 from "./pointdynomic.vue?vue&type=style&index=0&id=6479b549&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479b549",
  null
  
)

export default component.exports